module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.lists),
      expression: "!lists"
    }],
    attrs: {
      "data-qa": "Content-Timeline-Card"
    }
  }, [_c('div', {
    staticClass: "timeline-header",
    attrs: {
      "slot": "header",
      "data-qa": "Content-Timeline-Header"
    },
    slot: "header"
  }, [_c('span', {
    attrs: {
      "data-qa": "Content-TimelineHeader-Title"
    }
  }, [_vm._v(_vm._s(_vm.$t('timelineComponentTitle')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "data-qa": "Content-TimelineHeader-Button-ViewAll",
      "plain": "",
      "type": "primary"
    },
    on: {
      "click": _vm.openTimelineModel
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('timelineButtonViewAllText')) + "\n      ")])], 1), _vm._v(" "), _c('timeline-log', {
    attrs: {
      "log-list": _vm.lists,
      "fields": _vm.fields
    }
  })], 1), _vm._v(" "), _c('timeline-model', {
    attrs: {
      "showEventFilter": _vm.showEventFilter,
      "fields": _vm.fields
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f2579ea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Timeline/Timeline.vue
// module id = 959
// module chunks = 3